import type { ComponentMetaInput } from '../../ui';
import { AUTOMATION_PROMPT_FIELDS } from './automationPromptFields';

const fields = ['registration.enabled', 'smtp.enabled', 'smtp.host', 'smtp.port', 'smtp.secure', 'smtp.user', 'smtp.from', 'smtpPassword',
  'payment.enabled', 'payment.gatewayUrl', 'payment.pid', 'payment.notifyUrl', 'payment.returnUrl', 'payment.type', 'payment.minAmountCents', 'payment.orderTtlMinutes', 'payment.signType', 'paymentPrivateKey', 'paymentPublicKey',
  'features.autoMemory', 'features.showContextInjection', 'features.showReasoning',
  'moments.retentionHours', 'moments.configIdleRetentionHours', 'moments.minDecisionIntervalMinutes',
  ...['imageInitiative', 'ttsInitiative'].flatMap((kind) => ['enabled', 'user_priority', 'character_priority', 'balanced'].map((mode) => `features.${kind}.${mode}`)),
  ...AUTOMATION_PROMPT_FIELDS.map(([key]) => `features.automationPrompts.${key}`)];
const definitions: [string, ComponentMetaInput['role'], string][] = [
  ['root', 'container', 'Operations settings'], ['title', 'text', 'Operations settings heading'],
  ['readiness', 'text', 'Runtime readiness'], ['credentials', 'text', 'Credential configuration status'],
  ['form', 'container', 'Runtime settings form'], ['smtp', 'container', 'SMTP configuration'], ['smtpTitle', 'text', 'SMTP heading'],
  ['registration', 'container', 'Registration configuration'], ['registrationTitle', 'text', 'Registration heading'],
  ['features', 'container', 'Feature switches'], ['featuresTitle', 'text', 'Feature switch heading'],
  ['moments', 'container', '朋友圈离线设置'], ['momentsTitle', 'text', '朋友圈离线设置标题'],
  ['features.automationPrompts', 'container', '自动化提示词设置'],
  ['features.automationPrompts.title', 'text', '自动化提示词'],
  ['features.automationPrompts.restore', 'button', '恢复自动化默认提示词'],
  ...['imageInitiative', 'ttsInitiative'].flatMap((kind): [string, ComponentMetaInput['role'], string][] => [
    [`features.${kind}`, 'container', kind === 'imageInitiative' ? '生图积极性设置' : '语音 TTS 积极性设置'],
    [`features.${kind}.title`, 'text', kind === 'imageInitiative' ? '生图积极性' : '语音 TTS 积极性'],
  ]),
  ['payment', 'container', 'EasyPay configuration'], ['paymentTitle', 'text', 'EasyPay heading'],
  ['save', 'button', 'Save operations settings'], ['refresh', 'button', 'Refresh operations settings'], ['status', 'text', 'Operations status'],
  ...fields.flatMap((name): [string, ComponentMetaInput['role'], string][] => [[`${name}.label`, 'text', name], [name, 'input', name]]),
  ['tlsOption', 'text', 'SMTP TLS mode'], ['paymentOption', 'text', 'Payment method'],
  ['rsaHelp', 'text', 'RSA 密钥用途与保存说明'],
];
export const OPERATIONS_COMPONENTS: ComponentMetaInput[] = definitions.map(([name, role, label], index) => ({
  id: `operations.${name}`, page: 'admin', role, label, zIndex: 2,
  layout: { x: 16, y: 296 + (index % 10) * 44, width: 358, height: 44 },
  props: ['value', 'disabled'], notes: 'Embeddable scrolling administration form; coordinates are viewport templates.',
}));
export function operationsMeta(name: string): ComponentMetaInput {
  const meta = OPERATIONS_COMPONENTS.find((entry) => entry.id === `operations.${name}`);
  if (!meta) throw new Error(`Unknown operations component: ${name}`);
  return meta;
}
